export var PanelType;
(function (PanelType) {
    PanelType["helpCenter"] = "helpCenter";
    PanelType["releaseNote"] = "releaseNote";
    PanelType["onlineService"] = "onlineService";
    PanelType["feedback"] = "feedback";
    PanelType["questionnaire"] = "questionnaire";
    PanelType["hotline"] = "hotline";
    PanelType["hotFeedback"] = "hotFeedback";
    PanelType["hotQuestion"] = "hotQuestion";
    PanelType["hotQuestionSearch"] = "hotQuestionSearch";
    PanelType["lightSurvey"] = "lightSurvey";
})(PanelType || (PanelType = {}));
